module.exports = __webpack_public_path__ + "static/media/corona.0af2c73f.jpg";